export default {'version' : '1.0-19-g9e5d6e3'};
